export const USERS_FETCH_REQUESTED = 'USERS_FETCH_REQUESTED'
export const UPDATE_DEAL_TASK_REQUESTED = 'UPDATE_DEAL_TASK_REQUESTED'
export const DEAL_TASK_MARK_COMPLETED_REQUESTED = 'DEAL_TASK_MARK_COMPLETED_REQUESTED'
export const DEAL_TASK_MARK_NOT_COMPLETED_REQUESTED = 'DEAL_TASK_MARK_NOT_COMPLETED_REQUESTED'
export const DELETE_DEAL_TASK_REQUESTED = 'DELETE_DEAL_TASK_REQUESTED'
